<template>
  <header>
    <div class="row m-0">
      <div class="col-6">
        <div class="text-left p-3 pl-5">
          <img src="../../assets/logo.svg" alt="">
        </div>
      </div>
      <div class="col-6">
        <div class="profile cursor-pointer position-relative float-right" v-if="getAuthUser.name !== undefined" @click="show_menu = !show_menu">
          <div class="avatar mt-3">
            <b-avatar :src="getAuthUser.avatar"/>
            <span class="px-2">{{ getAuthUser.name }} {{ getAuthUser.surname }}</span>
            <img src="../../assets/img/arrowb-icon.png" alt="profile" class="dropdown">
          </div>
          <b-nav vertical class="menu" :class="{open: show_menu}">
            <b-nav-item><a href="/" @click.prevent="onShowProfile">Profile</a></b-nav-item>
            <b-nav-item><a href="/logout" @click.prevent="logout">Sign Out</a></b-nav-item>
          </b-nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'Header',
    data() {
      return {
        show_menu: false
      }
    },
    computed: {
      ...mapGetters([
        'getAuthUser',
      ])
    },
    methods: {
      ...mapActions([
        'logout',
        'showModal',
      ]),
      onShowProfile() {
        setTimeout(function () {
          this.show_menu = false
        }, 100)
        this.showModal({modal: 'ModalCurrentUser', data: this.getAuthUser})
      }
    }
  }
</script>

<style lang="scss">
  header {
    background: #242729;
    img { height: 46px }
    .profile {
      .avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        float: right;
        line-height: 16px;
        color: #fff;
        .dropdown {
          width: 16px;
          height: 16px;
        }
      }
      .menu {
        position: absolute;
        background: #fff;
        border: 1px solid #242729;
        border-radius: 3px;
        width: 100%;
        top: 55px;
        left: 0;
        z-index: 9;
        display: none;
        &.open {
          display: block;
        }
        a {
          color: #242729;
        }
      }
    }
  }

</style>